import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Email from './Email';
import { UrlPath } from 'utility/routes';
import ShoppingCart from './ShoppingCart';

interface CheckoutButtonProps {
  onSubmit: (event: React.FormEvent) => void;
  submitForm: boolean;
  email: string;
  onValidation: (errors: string[]) => void;
  onEmailChange: (value: string) => void;
  onEmailValidation: (errors: string[]) => void;
  acceptedTerms: boolean;
  onTermsChange: (value: boolean) => void;
  enableForm: boolean;
  overrideId?: string;
  appliedCoupon:string;
  setAppliedCoupon:React.Dispatch<React.SetStateAction<string>>
}

const Checkout: React.FC<CheckoutButtonProps> = ({
  onSubmit,
  submitForm,
  email,
  onEmailChange,
  onEmailValidation,
  acceptedTerms,
  onTermsChange,
  enableForm,
  overrideId,
  appliedCoupon,
  setAppliedCoupon
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const [emailErrors, setEmailErrors] = useState<string[]>([]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onTermsChange(event.target.checked);
  };

  const handleEmailValidation = (errors: string[]) => {
    setEmailErrors(errors);
  };

  return (
    <>
    {overrideId !== undefined  ?  <ShoppingCart companyId={overrideId} setAppliedCode={setAppliedCoupon} appliedCode={appliedCoupon}></ShoppingCart> : params.id !== undefined ?  <ShoppingCart companyId={params.id} setAppliedCode={setAppliedCoupon} appliedCode={appliedCoupon}></ShoppingCart> : null }
      <Email email={email} onEmailChange={onEmailChange} onValidation={onEmailValidation} />
      <div className="form-check mb-4">
        <input
          className="form-check-input"
          type="checkbox"
          value=""
          id="godkjenn"
          checked={acceptedTerms}
          onChange={handleCheckboxChange}
        />
        <label className="form-check-label small" htmlFor="godkjenn">
          Jeg godkjenner <a href="https://res.cloudinary.com/dm-1881/image/upload/terms/kundevilkaar-for-digitale-medier-1881-as-siste.pdf" target="_blank" rel="nofollow">avtalevilkårene</a>, og bekrefter å ha fullmakt til å inngå avtaler på vegne av selskapet.
        </label>
      </div>
      <p className="mb-0 mt-4">
        <button
          type="submit"
          className="btn btn-primary text-white me-1"
          disabled={!enableForm || submitForm}
        >
          Bestill {submitForm ? (<span className="spinner-border spinner-border-sm"></span>) : null}
        </button>
        <button onClick={() => navigate(`${UrlPath.MyAccount.Home}`)} className="btn btn-outline-primary" disabled={submitForm}>Avbryt</button>
      </p>
    </>
  );
};

export default Checkout;